/** Import react section **/
import React, { useEffect, useState } from 'react'
import { hasAuthorization } from '../../../store/session/sessionActions'
import queryString from 'query-string'
import { useLocation, useHistory } from 'react-router-dom'
import propTypes from 'prop-types'

/**Import Material UI section */
import {
	Button,
	Typography,
	Badge,
	Popper,
	Paper,
	ClickAwayListener,
	TextField,
	Chip,
	IconButton,
} from '@material-ui/core'
import DownloadIcon from '@material-ui/icons/ArrowDropDown'
import AddIcon from '@material-ui/icons/Add'

/**Import resources section */
import { FilterSelectStyles } from '../../../resources/styles/ServicesListStyles'

const FilterText = (props) => {
	const classes = FilterSelectStyles()
	let location = useLocation()
	let history = useHistory()
	const { nameFilter, nameFilterUrl, userProfile, roles } = props
	const [settingsEl, setSettingsEl] = useState(null)
	const [activeTerms, setActiveTerms] = useState([])
	const [inputValue, setInputValue] = useState('')

	/** Sync active terms from URL on load/change */
	useEffect(() => {
		const queryParams = queryString.parse(location.search)
		if (!!queryParams[nameFilterUrl]) {
			if (typeof queryParams[nameFilterUrl] !== 'string') setActiveTerms(queryParams[nameFilterUrl])
			else setActiveTerms([queryParams[nameFilterUrl]])
		} else {
			setActiveTerms([])
		}
	}, [location.search, nameFilterUrl])

	const handleMenuOpen = (event) => {
		setSettingsEl(event.currentTarget)
	}

	const onHandleClose = () => {
		setSettingsEl(null)
	}

	/** Add a new search term */
	const addTerm = () => {
		const trimmed = inputValue.trim()
		if (!trimmed) return
		if (activeTerms.includes(trimmed)) {
			setInputValue('')
			return
		}
		const newTerms = [...activeTerms, trimmed]
		setInputValue('')
		updateUrl(newTerms)
	}

	/** Remove a search term */
	const removeTerm = (term) => {
		const newTerms = activeTerms.filter((t) => t !== term)
		updateUrl(newTerms)
	}

	/** Sync terms to URL */
	const updateUrl = (terms) => {
		let queryParams = queryString.parse(location.search)
		if (terms.length > 0) {
			queryParams[nameFilterUrl] = terms
		} else {
			delete queryParams[nameFilterUrl]
		}
		history.push({ search: queryString.stringify(queryParams, { encode: false }) })
	}

	/** Handle Enter key */
	const handleKeyDown = (event) => {
		if (event.key === 'Enter') {
			event.preventDefault()
			addTerm()
		}
	}

	let isAuthorizer = hasAuthorization(userProfile, roles)
	let open = !!settingsEl

	return (
		<div className={classes.root}>
			{isAuthorizer && (
				<Badge badgeContent={activeTerms.length} color='error'>
					<Button
						endIcon={<DownloadIcon />}
						size='small'
						onClick={handleMenuOpen}
						className={activeTerms.length <= 0 ? classes.buttonFilter : classes.buttonFilterSelected}
					>
						<Typography variant='subtitle2'>{nameFilter}</Typography>
					</Button>
				</Badge>
			)}
			<Popper anchorEl={settingsEl} open={open} placement={'bottom'}>
				<ClickAwayListener onClickAway={onHandleClose}>
					<Paper elevation={2} className={classes.papperPopper}>
						<div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '8px' }}>
							<TextField
								size='small'
								variant='outlined'
								placeholder='Type to search...'
								value={inputValue}
								onChange={(e) => setInputValue(e.target.value)}
								onKeyDown={handleKeyDown}
								autoFocus
								style={{ flex: 1 }}
								InputProps={{ style: { fontSize: '0.8rem', height: '32px' } }}
							/>
							<IconButton size='small' onClick={addTerm} color='primary'>
								<AddIcon fontSize='small' />
							</IconButton>
						</div>
						<div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', maxWidth: '250px' }}>
							{activeTerms.map((term) => (
								<Chip key={term} label={term} size='small' onDelete={() => removeTerm(term)} />
							))}
						</div>
					</Paper>
				</ClickAwayListener>
			</Popper>
		</div>
	)
}

FilterText.propTypes = {
	userProfile: propTypes.shape({
		userName: propTypes.string.isRequired,
		name: propTypes.string.isRequired,
		email: propTypes.string.isRequired,
		avatarUrl: propTypes.string,
		enabled: propTypes.bool.isRequired,
		roles: propTypes.array,
	}),
	nameFilter: propTypes.string.isRequired,
	nameFilterUrl: propTypes.string.isRequired,
	roles: propTypes.array,
}

FilterText.defaultProps = {
	nameFilter: 'Filter',
	nameFilterUrl: 'textFilter',
	roles: [],
}

export default FilterText
